import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

/**
 * A wrapper around the Swiper component that handles errors gracefully
 * and ensures the component doesn't crash if Swiper has issues.
 */
const SafeSwiper = (props) => {
  const [error, setError] = useState(false);
  const [key, setKey] = useState(Date.now());

  // Add safe defaults to props
  const safeProps = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    ...props,
    // Avoid loop if we're experiencing errors
    loop: error ? false : props.loop
  };

  // Reset component on error
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(false);
        setKey(Date.now());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  return (
    <div className="safe-swiper-container">
      {error ? (
        <div className="swiper-fallback">
          <div className="container">
            <div className="row">
              {/* Render children as a simple grid if Swiper fails */}
              {React.Children.map(props.children, (child, index) => {
                if (child.type === SwiperSlide) {
                  return (
                    <div className="col-md-4 mb-4" key={index}>
                      {child.props.children}
                    </div>
                  );
                }
                return child;
              })}
            </div>
          </div>
        </div>
      ) : (
        <Swiper
          key={key}
          {...safeProps}
          onError={() => setError(true)}
        />
      )}
    </div>
  );
};

export default SafeSwiper; 